import { connectMediaStore } from './withOwnReduxStore';
import { getFlags } from '../../redux/flags/selectors';
export default connectMediaStore(function (state) { return ({
    flags: Object.keys(getFlags(state)),
}); }, {});
//# sourceMappingURL=withFeatureFlags.js.map